module.exports = __webpack_public_path__ + "static/img/pic_rjyf_xmal03.85c66076.png";